import { Container, Typography } from 'gu-ui-kit'
import CampaignCreateForm from 'modules/Forms/Account/Campaign/Create'
import formStyles from 'modules/Forms/common-form.module.scss'
import React from 'react'
import { useTranslation } from 'react-i18next'

const CampaignCreate = () => {
  const { t } = useTranslation()

  return (
    <Container
      display={'flex'}
      flexJustify={'center'}
    >
      <div className={formStyles['formContainer']}>
        <div className={formStyles['formContainer__inner']}>
          <Typography
            variant={'Subtitle-40'}
            component={'h1'}
            className={'margin-bottom-16'}
          >
            {t('services::forms.campaign_create.title')}
          </Typography>
          <CampaignCreateForm />
        </div>
      </div>
    </Container>
  )
}

export default CampaignCreate
